<template>
  <div class="container">
    <Header></Header>
    <div class="banner">
      <img src="../assets/images/img-hero-image-step123@2x.png" alt />
    </div>
    <div class="form-box">
      <div class="form-top">
        <div class="line"></div>
        <img class="icon left" src="../assets/images/icon-correct@2x.png" alt />
        <img class="icon mid" src="../assets/images/icon-correct@2x.png" alt />
        <img class="icon right" src="../assets/images/icon-payment-grey@2x.png" alt />
      </div>
      <div class="form-mid">
        <span class="left active" v-text="$t('msg.quantity')"></span>
        <span class="mid active" v-text="$t('msg.personalDet')">Personal Details</span>
        <span class="right" v-text="$t('msg.payment')">Payment</span>
      </div>
      <div class="form-bottom">
        <div class="total-box">
          <p>
            <span class="label" v-text="$t('msg.qty')"></span>
            <span class="count" v-text="count"></span>
          </p>
          <p>
            <span class="label" v-text="$t('msg.total')"></span>
            <span class="totalPrice">
              <strong v-text="currency"></strong>
              <strong v-text="count*price"></strong>.00
            </span>
          </p>
        </div>
        <h2>
          <img src="../assets/images/icon-pay-safe@2x.png" alt />
          <span v-text="$t('msg.paymentTopTip')"></span>
        </h2>
        <div class="form-inner" id="card-element">
          <p v-text="$t('msg.cardNumberLabel')"></p>
          <!-- <input type="number" data-stripe="number" v-model.trim="cardNumber"> -->
          <input
            :class="{requireClass:cardRequired, cardErrorClass:cardError}"
            type="text"
            v-model.trim="cardNumber"
            data-stripe="number"
            @keyup="bankCardKeyup"
          />
          <span v-if="cardRequired" v-text="$t('error.requiredErr')"></span>
          <span v-if="cardError" v-text="$t('error.cardError')"></span>
        </div>
        <div class="form-inner clearfix">
          <div class="expiry-date">
            <p v-text="$t('msg.expiryDateLabel')"></p>
            <input
              :class="{requireClass:dateRequired, dateErrorClass:dateError}"
              type="text"
              v-model="expiryDate"
              placeholder="MM/YY"
            />
            <span v-if="dateRequired" v-text="$t('error.requiredErr')"></span>
            <span v-if="dateError" v-text="$t('error.dateError')"></span>
          </div>
          <div class="cvv">
            <p>
              <strong v-text="$t('msg.cvvLabel')"></strong>
              <img src="../assets/images/icon-cvv@2x.png" alt />
            </p>
            <input :class="{requireClass:cvvRequired}" type="password" v-model.trim="cvv" />
            <span v-if="cvvRequired" v-text="$t('error.requiredErr')"></span>
            <span v-if="cvvError" v-text="$t('error.cvvError')"></span>
          </div>
        </div>
        <div class="form-btn" @click="pay">
          <span v-if="!showLoading" v-text="$t('msg.payNowBtn')">Pay Now</span>
          <img class="loading" src="../assets/images/loading.svg" alt v-if="showLoading" />
        </div>
        <h3>
          <span v-text="$t('msg.paymentBotTip1')"></span>
          <a
            href="https://en.dragonpass.com.cn/info/termsofuse"
            target="_blank"
            v-text="$t('msg.paymentBotTip2')"
          ></a>
          <span v-text="$t('msg.paymentBotTip3')"></span>
          <a
            href="https://en.dragonpass.com.cn/info/privacypolicy"
            target="_blank"
            v-text="$t('msg.paymentBotTip4')"
          ></a>.
        </h3>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { setTimeout } from "timers";

export default {
  name: "payment",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      reg: /^[0-9]+.?[0-9]*$/,
      cardRequired: false,
      cardError: false,
      dateRequired: false,
      dateError: false,
      cvvRequired: false,
      cvvError: false,
      cardNumber: "",
      expiryDate: "",
      cvv: "",
      showLoading: false
    };
  },
  created() {
    const oScript = document.createElement("script");
    oScript.type = "text/javascript";
    oScript.src = "https://js.stripe.com/v2/";
    // oScript.src = "../assets/js/stripe.js";
    document.body.appendChild(oScript);
  },
  mounted() {
    setTimeout(() => {
      this.$axios.get("/api/order/stripe/key").then(res => {
        if (res.data.state === "11") {
          Stripe.setPublishableKey(res.data.data);
        }
      });
    }, 5000);
  },
  methods: {
    bankCardKeyup(e) {
      let self = this;
      // 如果是删除键，则不加空格，且删去字符串末端空格
      if (e.keyCode === 8) {
        self.cardNumber = self.cardNumber.replace(/[\s\n\t]+$/g, "");
        return;
      }
      self.cardNumber = self.cardNumber.replace(/[^0-9|' ']*/g, "");
      let value = self.cardNumber.replace(/[^0-9]*/g, "");
      if (value.length > 4 && value.length <= 8) {
        self.cardNumber =
          value.slice(0, 4) + " " + value.slice(4, value.length);
      } else if (value.length > 8 && value.length <= 12) {
        self.cardNumber =
          value.slice(0, 4) +
          " " +
          value.slice(4, 8) +
          " " +
          value.slice(8, value.length);
      } else if (value.length > 12 && value.length <= 16) {
        self.cardNumber =
          value.slice(0, 4) +
          " " +
          value.slice(4, 8) +
          " " +
          value.slice(8, 12) +
          " " +
          value.slice(12, value.length);
        if (value.length === 16) {
          // 调用识别银行卡函数
        }
      } else if (value.length > 16) {
        self.cardNumber =
          value.slice(0, 4) +
          " " +
          value.slice(4, 8) +
          " " +
          value.slice(8, 12) +
          " " +
          value.slice(12, 16) +
          " " +
          value.slice(16, value.length);
        if (value.length === 19) {
          // 调用识别银行卡函数
        } else if (value.length > 19) {
          self.cardNumber =
            value.slice(0, 4) +
            " " +
            value.slice(4, 8) +
            " " +
            value.slice(8, 12) +
            " " +
            value.slice(12, 16) +
            " " +
            value.slice(16, 19);
        }
      }
    },
    pay() {
      var _this = this;
      var firNum;
      if (this.expiryDate.length >= 2 && this.expiryDate.length <= 5) {
        firNum = this.expiryDate.substring(0, 2);
        firNum = firNum.replace(/\b(0+)/gi, "");
      }
      if (this.cardNumber === "") {
        this.cardRequired = true;
      } else if (this.cardNumber.length < 16 || this.cardNumber.length > 19) {
        this.cardError = true;
      } else if (this.expiryDate === "") {
        this.dateRequired = true;
      } else if (this.expiryDate.length < 5 || firNum > 13) {
        this.dateError = true;
      } else if (this.cvv === "") {
        this.cvvRequired = true;
      } else if (this.cvv.length < 3) {
        this.cvvError = true;
      } else {
        _this.showLoading = true;
        var detail = JSON.parse(sessionStorage.getItem("detailData"));

        //请求第三方支付
        Stripe.card.createToken(
          {
            number: _this.cardNumber,
            cvc: _this.cvv,
            exp_month: _this.expiryDate.substring(0, 2),
            exp_year: _this.expiryDate.substring(3, 5)
          },
          function(status, response) {
            if (response.error) {
              //请求失败
              if (response.error.code === "invalid_expiry_year") {
                _this.dateError = true;
                _this.showLoading = false;
                return false;
              } else {
                _this.$router.push({ path: "/error" });
              }
            } else {
              //请求成功
              var token = response.id;

              // 支付请求
              _this.$axios
                .post(
                  "/api/order/lounge",
                  {
                    amount: _this.count * _this.price,
                    email: detail.email,
                    countyAbbr: detail.countryCode,
                    name: detail.name,
                    phone: detail.mobileNumber,
                    num: _this.count,
                    stripeToken: token
                    // currency: _this.$store.state.currency
                  },
                  {
                    headers: {
                      language: _this.$i18n.locale,
                      token: localStorage.getItem("pass")
                    }
                  }
                )
                .then(res => {
                  if (res.data.state === "11") {
                    _this.$router.push({ path: "/success" });
                  } else {
                    _this.$router.push({ path: "/error" });
                  }
                })
                .catch(err => {
                  _this.showLoading = false;
                });
            }
          }
        );
      }
    }
  },
  watch: {
    cardNumber(curVal, oldVal) {
      const str = curVal.replace(/\s+/g, "");
      if (curVal !== "") {
        this.cardRequired = false;
      }
      if (str.length >= 16 || str <= 19) {
        this.cardError = false;
      }
    },
    expiryDate(curVal, oldVal) {
      if (curVal === "") {
        this.dateError = false;
      }

      if (curVal !== "") {
        this.dateRequired = false;
      }

      if (curVal.length > 5) {
        this.expiryDate = oldVal;
        return false;
      }

      // 限制只能输入数字
      if (!this.reg.test(curVal)) {
        this.expiryDate = "";
        return false;
      }

      var firNum;
      if (curVal.length >= 2) {
        firNum = curVal.substring(0, 2);
        firNum = firNum.replace(/\b(0+)/gi, "");
        if (firNum <= 12) {
          this.dateError = false;
        }
      }

      //输入两位数字后自动加斜杠
      if (curVal.length > oldVal.length) {
        if (curVal.length == 2) {
          this.expiryDate = curVal + "/";
        }
      }
    },
    cvv(curVal, oldVal) {
      if (curVal === "") {
        this.cvvError = false;
      }

      if (curVal !== "") {
        this.cvvRequired = false;
      }

      if (curVal.length == 3) {
        this.cvvError = false;
      }

      if (curVal.length > 3) {
        this.cvv = oldVal;
      }
    }
  },
  computed: {
    count() {
      return this.$store.state.count;
    },
    price() {
      return this.$store.state.price;
    },
    currency() {
      return this.$store.state.currency;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  background: #f5f6fa;
}
.banner {
  height: 300px;
}
.banner img {
  width: 100%;
  height: 100%;
}
.form-top {
  width: 550px;
  margin: 50px auto 0;
  height: 100px;
  position: relative;
}
.form-top .line {
  width: 100%;
  height: 2px;
  background: #d1d3e0;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -1px;
}
.form-top .icon {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 50%;
  margin-top: -30px;
  z-index: 2;
}
.form-top .left {
  left: -30px;
}
.form-top .mid {
  left: 50%;
  margin-left: -30px;
}
.form-top .right {
  right: -30px;
}
.form-mid {
  width: 550px;
  margin: 0 auto 70px;
  position: relative;
}
.form-mid span {
  font-size: 16px;
  font-weight: bold;
  color: #7b8090;
  text-align: center;
  position: absolute;
}
.form-mid .active {
  color: #4cc663;
}
.form-mid .left {
  width: 114px;
  left: -57px;
}
.form-mid .mid {
  width: 138px;
  left: 50%;
  margin-left: -69px;
}
.form-mid .right {
  width: 114px;
  right: -57px;
}
.form-bottom {
  width: 620px;
  margin: 0 auto;
  position: relative;
}
.form-bottom h2 {
  font-size: 16px;
  font-weight: normal;
  color: #2d354d;
  margin: 30px 0;
}
.form-bottom h2 img {
  float: left;
  width: 20px;
  height: 22.5px;
  margin-right: 10px;
}
.form-inner {
  margin-bottom: 20px;
}
.form-inner p {
  font-size: 16px;
  font-weight: bold;
  color: #2d354d;
  margin-bottom: 10px;
}
.form-inner input {
  width: 96%;
  height: 30px;
  border: 1px #707070 solid;
  border-radius: 4px;
  font-size: 18px;
  outline: none;
  padding: 7px 2%;
}
.form-inner span {
  font-size: 12px;
  font-weight: bold;
  color: #e73737;
}
.form-bottom h3 {
  font-size: 12px;
  font-weight: normal;
  text-align: center;
  margin: 20px 0 50px;
}
.form-bottom h3 a {
  color: #42a6ea;
}
.form-btn {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #910000;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  border-radius: 8px;
  margin-top: 30px;
  cursor: pointer;
  position: relative;
}
.form-btn .loading {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}

.expiry-date {
  float: left;
  width: 49%;
}
.cvv {
  float: right;
  width: 49%;
  position: relative;
}
.form-inner .cvv img {
  width: 36px;
  height: 27.5px;
  position: absolute;
  left: 44px;
  top: -8px;
}
.total-box {
  background: #fff;
  padding: 20px;
}
.total-box p {
  overflow: hidden;
}
.total-box .label {
  float: left;
  font-size: 16px;
  font-weight: bold;
  color: #7b8090;
}
.total-box .count,
.total-box .totalPrice {
  float: right;
  font-size: 16px;
  font-weight: bold;
  color: #2d354d;
}
.form-inner .requireClass {
  border: 1px #e73737 solid;
}
.form-inner .dateErrorClass {
  border: 1px #e73737 solid;
}
.form-inner .cardErrorClass {
  border: 1px #e73737 solid;
}

@media screen and (max-width: 640px) {
  .banner {
    height: 200px;
  }
  .form-top .icon {
    width: 40px;
    height: 40px;
    margin-top: -20px;
  }
  .form-top .left {
    left: -20px;
  }
  .form-top .mid {
    margin-left: -20px;
  }
  .form-mid span {
    font-size: 10px;
  }
  .form-top .right {
    right: -20px;
  }
  .form-top,
  .form-mid {
    width: 70%;
  }
  .form-bottom {
    width: 90%;
  }
  .form-top {
    height: 70px;
    margin: 20px auto 0;
  }
  .form-mid {
    margin: 0 auto 60px;
  }
  .expiry-date,
  .cvv {
    width: 100%;
  }
  .expiry-date {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .form-inner span {
    font-size: 10px;
  }
  .form-inner input {
    width: 92%;
    padding: 7px 4%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Payment.vue